import TerminalStripTreeViewModel from "../modelTreeViews/TerminalStripTreeviewModel";
import BaseModel from "./BaseModel";
import BaseModelMap from "./BaseModelMap";
import BaseObject from "./BaseObject";

import { copyAllProperties, makeStringSortable, sortArrayByProperty } from "./utils";

import Logger from "../Logger";

const logger = new Logger();
//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import Terminal, { TerminalListBridgeInfo } from "./Terminal";
import Cabinet from "./Cabinet";
import { channelTypeInfo } from "./ChannelType";
import TerminalBlock from "./TerminalBlock";
import { TerminalStripVoltageLevel } from "./Consumer";
import type { DeviceCabinetPlacement } from "./DeviceCabinetPlacement";

ObjectFactory.registerClass("TerminalStrip", (data?: any, parent?: BaseModel) => {
  return new TerminalStrip({});
});

type InfoForOneElcbOrFuse = { lastIfound: number; firstIfound: number; obj: BaseModel; tag: string };

//////////////////////////////////////////////////
export default class TerminalStrip extends BaseModel {
  public get className(): string {
    return "TerminalStrip"; // no itx
  }

  terminals = new BaseModelMap<Terminal>(Terminal, this, "t");

  // -----------------------------------------------------------------------------
  // cabinetPlacement
  // -----------------------------------------------------------------------------
  _cabinetPlacement?: DeviceCabinetPlacement;
  get cabinetPlacement(): DeviceCabinetPlacement | undefined {
    return this._cabinetPlacement;
  }

  set cabinetPlacement(newValue: DeviceCabinetPlacement | undefined) {
    if (this._cabinetPlacement === newValue) return;
    this.beforeChange("cabinetPlacement");
    this._cabinetPlacement = newValue;
    this.changed("cabinetPlacement");
  }

  // -----------------------------------------------------------------------------
  numberOfWiresPerTerminal = 2;
  type = "doppelstockklemme"; // dreifachstockklemmen || einfachstockklemmen  // no itx
  //  {
  //   wireSize: "1-2",
  //   curretRating: "150%", //The current rating is based on the conductivity of the terminals, cross-sectional area, and the corresponding heat rise.
  //   voltageRating: 20, // The maximum system voltage of the application must be less than the voltage rating.
  // };

  // -----------------------------------------------------------------------------
  // voltageLevel
  // -----------------------------------------------------------------------------
  _voltageLevel: TerminalStripVoltageLevel = TerminalStripVoltageLevel.V230;
  get voltageLevel(): TerminalStripVoltageLevel {
    return this._voltageLevel;
  }

  set voltageLevel(newValue: TerminalStripVoltageLevel) {
    if (this._voltageLevel === newValue) return;
    this.beforeChange("voltageLevel");
    this._voltageLevel = newValue;
    this.changed("voltageLevel");
  }

  // -----------------------------------------------------------------------------

  getPersistentProperties(): string[] {
    return ["terminals", "voltageLevel", "cabinetPlacement", ...super.getPersistentProperties()]; // no itx
  }

  emptyTagIsForbidden(): boolean {
    return true;
  }

  canBeEditedInteractive(): boolean {
    return false;
  }
  /////////////////////////////////////////////////////////////////////////////////
  // if the connected channels of this actor are already connected with terminals and or fuses it should not be possible
  // -> to much confusion for user if moving is possible or not
  ///////////
  canBeMovedToNewParent(newParent: BaseModel) {
    return false;
  }

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    copyAllProperties(data, this);
    this.treeViewModel = new TerminalStripTreeViewModel(this);
  }

  delete(): Array<BaseObject> {
    this.isDeleting = true;
    var res = new Array<BaseObject>();
    res = res.concat(this.terminals.deleteAllItems());
    res = res.concat(super.delete());
    return res;
  }

  getParentChildrenGroup(): Array<BaseModel> | undefined {
    return (this.parent as Cabinet)?.terminalStrips.sortBy("tag");
  }

  getTerminalBlocks(): Array<TerminalBlock> {
    const res = new Array<TerminalBlock>();

    let currentBlock: TerminalBlock | undefined;

    let terminalIndex = 0;

    let last: Terminal | undefined;
    this.terminals.sortBy("tag").forEach((terminal) => {
      terminal.isLast = false;
      if (terminal.isMasterTerminal) {
        if (last) {
          last.isLast = true;
        }
        currentBlock = new TerminalBlock(terminal, []);
        terminal._terminalBlock = currentBlock; // cache für getTerminalBlock zur SpeedOptimierung !!!!
        terminal.terminalIndex = 0; // default für 3 adrige Leitung, braun
        terminalIndex = 1;

        res.push(currentBlock);
      } else {
        currentBlock?.subTerminals.push(terminal);
        terminal._terminalBlock = currentBlock; // cache für getTerminalBlock zur SpeedOptimierung !!!!
        terminal.terminalIndex = terminalIndex++;
      }
      last = terminal;
    });

    if (last) last.isLast = true;

    return res;
  }

  updateAll() {
    const sortedTerminals = this.terminals.sortBy("tag");

    //
    // Abstand zwischen den terminals schaffen,
    //  um zusätzlcihe Klemmen konfliktfrei einfügen zu können
    //

    // sortedTerminals.forEach((terminal) => {
    //   terminal.tagIndex = terminal.tagIndex * 10;
    // });

    if (sortedTerminals.length <= 1) {
      return;
    }

    //
    //  Größe der Klemmenblocks an die Aderzahl des Kabels anpassen
    //
    const terminalBlocks = this.getTerminalBlocks();
    terminalBlocks.forEach((terminalBlock) => {
      terminalBlock.assignSizeFromCableType();
    });
  }

  updatCableSizes() {
    const sortedTerminals = this.terminals.sortBy("tag");

    //
    // Sicher stellen, dass die Klemme für die Aderszahl genügen Platz hat
    //
    const terminalBlocks = this.getTerminalBlocks();
    terminalBlocks.forEach((terminalBlock) => {
      const consumer = terminalBlock.mainTerminal.consumer;
      const cableType = consumer?.cableType;

      if (cableType) {
        const neededSize = (cableType.numberOfWires - 1) / 2;

        terminalBlock.adjustSize(neededSize);
      }
    });
  }

  checkElcbUsage() {
    let errors: string[] = [];
    const terminalBlocks = this.getTerminalBlocks();
    terminalBlocks.forEach((terminalBlock) => {
      terminalBlock.checkElcbUsage();
    });
  }

  renumberTermialBlocks(terminalBlocks: Array<TerminalBlock>) {
    let i = 1;
    for (const terminalBlock of terminalBlocks) {
      const terminalBlockSize = terminalBlock.size;
      terminalBlock.assignNewTagIndex(i);
      i = i + terminalBlockSize;
    }
  }

  renumber(optimize: boolean) {
    try {
      this.updateAll();

      let xTerminalBlocks = this.getTerminalBlocks();

      if (optimize) {
        //
        // sortiere Teminal blocks nach (Fuse, fullTag)
        //
        xTerminalBlocks.forEach((terminalBlock) => {
          if (terminalBlock.hasNoConnectedConsumers) {
            terminalBlock.delete();
            xTerminalBlocks = xTerminalBlocks.filter((tb) => tb !== terminalBlock);
          }

          const consumer = terminalBlock.mainTerminal.consumer;
          const consumerTag = consumer?.fullTag.toUpperCase() || `xxxxxxx`;

          let fuse = terminalBlock.mainTerminal.fuse;
          if (!fuse) {
            for (let terminal of terminalBlock.subTerminals) {
              if (terminal.consumer) {
                fuse = terminal.consumer.fuse;
                if (fuse) {
                  break;
                }
              }
            }
          }

          const fuseTag = fuse?.tag.toUpperCase() || `xxxxxxx`;

          const elcb = fuse?.parent;
          const elcbTag = elcb?.tag.toUpperCase() || `xxxxxxx`;

          //
          // feste Verbraucher immer an den Anfang packen
          //
          let supply = `X`;
          if (consumer) {
            if (channelTypeInfo(consumer.channelType).isSupply) {
              supply = "A";
            }
          }

          terminalBlock.sortString = makeStringSortable(`${elcbTag}_${supply}_${fuseTag}_${consumerTag}`);

          console.log(`sortString ${terminalBlock.mainTerminal.tag} ${terminalBlock.sortString}`);
        });

        xTerminalBlocks = sortArrayByProperty(xTerminalBlocks, "sortString"); // no itx
      }

      this.renumberTermialBlocks(xTerminalBlocks);
    } catch (ex) {
      logger.error(ex);
    }

    this.raiseOnChange("childCollection");
  }

  calcFirstAndLastUsageInfos(xTerminals: Array<Terminal>, forElcbs: boolean): Array<InfoForOneElcbOrFuse> {
    const infos = new Map<string, InfoForOneElcbOrFuse>();

    function findFirstAndLastUsage(i: number, t: Terminal, elcbOrFuse: BaseModel) {
      // Only the block's main terminal carries N; add-on terminals carry L/+ wires.
      if (forElcbs && !t.isMasterTerminal) return;
      let info = infos.get(elcbOrFuse.id);
      if (!info) {
        info = { lastIfound: -1, firstIfound: -1, obj: elcbOrFuse, tag: elcbOrFuse.tag };
        infos.set(elcbOrFuse.id, info);
      }

      const tChannel = t.channel;
      if (forElcbs || (tChannel && channelTypeInfo(tChannel?.channelType).isSupply)) {
        if (t.elcb == elcbOrFuse || t.fuse == elcbOrFuse) {
          if (info.firstIfound == -1) {
            info.firstIfound = i;
          }
          info.lastIfound = i;
        }
      }
    }

    /////////////////////////////////////////////////////////////////////////////
    let i = 0;
    xTerminals.forEach((t) => {
      if (forElcbs) {
        if (t.elcb) {
          findFirstAndLastUsage(i, t, t.elcb);
        }
      } else {
        if (t.fuse) {
          findFirstAndLastUsage(i, t, t.fuse);
        }
      }

      i++;
    });

    const res = new Array<InfoForOneElcbOrFuse>();
    infos.forEach((i) => res.push(i));
    return res;
  }

  calcListInfos(): Array<Terminal> {
    const xTerminals = this.terminals.sortBy("tag");

    //
    // Calculates "isLast"
    //
    this.getTerminalBlocks();

    let firstAndLastUsageInfos_elcb = this.calcFirstAndLastUsageInfos(xTerminals, true);
    let firstAndLastUsageInfos_fuse = this.calcFirstAndLastUsageInfos(xTerminals, false);

    firstAndLastUsageInfos_elcb = sortArrayByProperty(firstAndLastUsageInfos_elcb, "tag");
    firstAndLastUsageInfos_fuse = sortArrayByProperty(firstAndLastUsageInfos_fuse, "tag");

    //  filter fuses with only one usage in one terminal
    firstAndLastUsageInfos_fuse = firstAndLastUsageInfos_fuse.filter(
      (i) => i.firstIfound >= 0 && i.firstIfound < i.lastIfound,
    );

    let i = 0;
    xTerminals.forEach((terminal) => {
      terminal.elcbInfos = new Array<TerminalListBridgeInfo>();

      firstAndLastUsageInfos_elcb.forEach((elcb_info) => {
        terminal.elcbInfos!.push({
          bridgeIn: i > elcb_info.firstIfound && i <= elcb_info.lastIfound,

          bridgeOut: i >= elcb_info.firstIfound && i < elcb_info.lastIfound,
          dot: terminal.isMasterTerminal && terminal.elcb == elcb_info.obj,
          obj: elcb_info.obj,
        });
      });

      terminal.fuseInfos = new Array<TerminalListBridgeInfo>();
      firstAndLastUsageInfos_fuse.forEach((fuse_info) => {
        let dot = terminal.fuse == fuse_info.obj;
        if (terminal.consumer && !channelTypeInfo(terminal.consumer.channelType).isSupply) {
          dot = false;
        }

        terminal.fuseInfos!.push({
          bridgeIn: i > fuse_info.firstIfound && i <= fuse_info.lastIfound,
          bridgeOut: i >= fuse_info.firstIfound && i < fuse_info.lastIfound,
          dot: dot,
          obj: fuse_info.obj,
        });
      });
      i++;
    });

    return xTerminals;
  }
}
